import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Grid, TextField, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import '../../../Styles/react-tagsinput.css'
import brokerGroupApi from "../../../api/brokerGroupApi";
import { ContextNotification, severitys } from "../../../App";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import FlightCompensationApi from "../../../api/FlightCompensationApi";
import helper from "../../../helper";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import staticVariablesApi from "../../../api/staticVariablesApi";
import EnumMapper from "../../../EnumMapper";
import { MdAdd, MdEditSquare } from "react-icons/md";
import CustomTitle from "../../../Components/CustomTitle";


const EditAirLineSlA = ({ row, Refresh }) => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const { setOpen } = useContext(ContextNotification);
  const customization = useSelector((state) => state.customization);
  const [airLines, setAirLines] = useState([]);
  const [operations, setOperations] = useState([]);
  const [currency, setCurrency] = useState([]);
  const schema = yup.object().shape({
    operationId: yup.string().required(' عملیات عمره را انتخاب کنید'),
    airLineId: yup.string().required(' شرکت هواپیمایی را انتخاب کنید'),
    departureCurrency: yup.string().required(' نوع ارز خروجی را انتخاب کنید'),
    returnCurrency: yup.string().required(' نوع ارز بازگشتی را انتخاب کنید'),
    taxes: yup.string().required(" مقدار عوارض و مالیات را وارد کنید")
  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
    defaultValues: {
      operationId: row?.operation ? String(row.operation) : null,
      airLineId: row?.airLine ? String(row?.airLine) : null,
      taxes: row?.dutiesAndTaxes ? String(row?.dutiesAndTaxes) : '',
      departureCurrency: row?.departureCurrency ? String(row?.departureCurrency) : null,
      returnCurrency: row?.returnCurrency ? String(row?.returnCurrency) : null
    },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    GetAirLineDropDown();
    GetOperationDropDown();
    GetCurrencyDropDown();
  }, [])
  const GetAirLineDropDown = () => {
    staticVariablesApi.GetAirLineType().then((res) => {
      const arr = helper.DictionayToList(res.data.data);
      setAirLines(arr.map((o) => {
        return {
          id: o.key,
          label: o.value
        };
      }));
    }
    )
      .catch((error) => {
        console.log(error);
      })
  }
  const GetOperationDropDown = () => {
    brokerGroupApi.GetOprationDropDown().then((res) => {
      const arr = helper.DictionayToList(res.data.data);
      setOperations(arr.map((o) => {
        return {
          id: o.key,
          label: o.value
        };
      }));
    }
    )
      .catch((error) => {
        console.log(error);
      })
  }
  const GetCurrencyDropDown = () => {
    staticVariablesApi.GetCurrency().then((res) => {
      const arr = helper.DictionayToList(res.data.data);
      setCurrency(arr.map((o) => {
        return {
          id: o.key,
          label: o.value
        };
      }));
    }
    )
      .catch((error) => {
        console.log(error);
      })
  }
  const formatNumber = (num) => {
    if (!num) return "";
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, "");
    if (!/^\d*$/.test(rawValue)) {
      setValue("taxes", "");
      return;
    }
    setValue("taxes", formatNumber(rawValue));
  };
  const undoformatNumber = (value) => {
    const rawValue = value.replace(/,/g, "");
    return rawValue;
  };
  const onSubmit = () => {
    var airline = null;
    if (watch("airLineId"))
      airline = watch("airLineId")
    var operationId = null;
    if (watch("operationId"))
      operationId = watch("operationId")
    var departureCurrency = null;
    if (watch("departureCurrency"))
      departureCurrency = watch("departureCurrency")
    var returnCurrency = null;
    if (watch("returnCurrency"))
      returnCurrency = watch("returnCurrency")
    var taxes = null;
    if (watch("taxes"))
      taxes = undoformatNumber(watch("taxes"))
    const data = {
      'airLine': parseInt(airline),
      'operation': parseInt(operationId),
      'dutiesAndTaxes': parseInt(taxes),
      'departureCurrency': parseInt(departureCurrency),
      'returnCurrency': parseInt(returnCurrency)
    }
    setSubmitLoading(true);
    if ((!row) || (row === null))//add mode
    {
      FlightCompensationApi.AddAirLineSLA(data).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            setOpen({ IsEnable: true, Message: 'توافقنامه با موفقیت افزوده شد', severity: severitys.success });
            resetForm();
          }
          else {
            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

          }

        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
        }

      }).catch(err => {

        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }

      }).finally(() => { setSubmitLoading(false) });
    }
    else {
      FlightCompensationApi.UpdateAirLineSLA(row.id, data).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            setOpen({ IsEnable: true, Message: 'ویرایش توافقنامه با موفقیت انجام شد', severity: severitys.success });
            resetForm();
            Refresh();
          }
          else {
            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

          }

        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
        }

      }).catch(err => {

        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }

      }).finally(() => { setSubmitLoading(false) });
    }

  }

  const resetForm = () => {
    setValue("operationId", "");
    setValue("airLineId", "");
    setValue("departureCurrency", "");
    setValue("returnCurrency", "");
    setValue("taxes", "");
  }
  return (
    <Box sx={{ m: 2 }}>
      <ThemeProvider theme={customtheme(customization)}>
        <RtlProvider>
          {(row === null) && <CustomTitle title={'افزودن توافقنامه هواپیمایی'} icon={<MdAdd size={24} />} />}
          <form onSubmit={handleSubmit(onSubmit)}>

            <Grid container spacing={1} >
              <Grid item md={2} xs={7}  >
                <RHFAutocomplete
                  control={control}
                  options={operations}
                  name="operationId"
                  placeholder="عملیات عمره"
                  style={{
                    border: "none",
                    padding: 0
                  }}
                />
                <p className="error">{errors.operationId?.message}</p>
              </Grid>

              </Grid>
              <Grid container spacing={1} >
                              <Grid item md={1.5} xs={7}>
                <RHFAutocomplete
                  control={control}
                  options={airLines}
                  name="airLineId"
                  placeholder="شرکت هواپیمایی"
                  style={{
                    border: "none",
                    padding: 0
                  }}
                />
                <p className="error">{errors.airLineId?.message}</p>
              </Grid>
              <Grid item md={1.5} xs={7}>
                <TextField label="عوارض و مالیات"
                  {...register("taxes")}
                  onChange={handleChange}
                  fullWidth></TextField>
                <p className="error">{errors.taxes?.message}</p>
              </Grid>
              
              </Grid>
              <Grid container spacing={1} >
                <Grid item md={1.5} xs={7}>
                <RHFAutocomplete
                  control={control}
                  options={currency}
                  name="departureCurrency"
                  placeholder="نوع ارز خروجی"
                  style={{
                    border: "none",
                    padding: 0
                  }}
                />
                <p className="error">{errors.departureCurrency?.message}</p>
              </Grid>
              <Grid item md={1.5} xs={7}>
                <RHFAutocomplete
                  control={control}
                  options={currency}
                  name="returnCurrency"
                  placeholder="نوع ارز بازگشتی"
                  style={{
                    border: "none",
                    padding: 0
                  }}
                />
                <p className="error">{errors.returnCurrency?.message}</p>

              </Grid>
             </Grid>


                <Button type="submit" disabled={submitLoading} variant="contained" color="primary" sx={{width:'200px'}} >
                  <BeatLoading loading={submitLoading} color={"#e65100"} /> {((row) && (row !== null)) ? 'ویرایش' : 'ثبت'}</Button>
              
             
          </form>
        </RtlProvider>
      </ThemeProvider>
    </Box>
  )
}
export default EditAirLineSlA